export default __webpack_public_path__ + "static/jongchanchoi-89cafb6a318fd6716eb8f5f73faa6612.png";